var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#404040"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_1558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 13.7501H7.33366C7.02424 13.7501 6.72749 13.6272 6.5087 13.4084C6.28991 13.1896 6.16699 12.8928 6.16699 12.5834V7.33341C6.16699 7.024 6.28991 6.72725 6.5087 6.50846C6.72749 6.28966 7.02424 6.16675 7.33366 6.16675H12.5837C12.8931 6.16675 13.1898 6.28966 13.4086 6.50846C13.6274 6.72725 13.7503 7.024 13.7503 7.33341V7.91675M11.417 10.2501H16.667C17.3113 10.2501 17.8337 10.7724 17.8337 11.4167V16.6667C17.8337 17.3111 17.3113 17.8334 16.667 17.8334H11.417C10.7727 17.8334 10.2503 17.3111 10.2503 16.6667V11.4167C10.2503 10.7724 10.7727 10.2501 11.417 10.2501Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_1558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.2c3f37c4f4e7d5c8b4435b3c10a15a85.svg";
export { ForwardRef as ReactComponent };